import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { KassiererListView } from './list-view/kassierer.list-view';

export const kassiererFieldOk: FieldOkConfig = {
  name: 'kassierer',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassierer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KassiererListView,
      },
    },
  ],
};
export const kassiererMultiselectFieldOk: FieldOkConfig = {
  name: 'kassierer',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassierer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: KassiererListView,
      },
    },
  ],
};

export const kassiererQueryFieldOk: FieldOkConfig = {
  name: 'kassierer',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassierer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KassiererListView,
      },
    },
  ],
};
